<div class="browse-filter">
  <div class="affiner-rech">
    <span fxHide.md="true" fxHide.lg="true"></span>
    <span>{{ 'globalUi.filter.title' | translate }}</span>
    <button mat-icon-button type="button" (click)="closeSideNav()" fxHide="true" fxHide.xs="false" fxHide.sm="false">
      <svg xmlns="http://www.w3.org/2000/svg" id="prefix__add-24px" width="24" height="24" viewBox="0 0 24 24">
        <path id="prefix__Path_443" fill="#fff" d="M18 13h-5v5a1 1 0 0 1-2 0v-5H6a1 1 0 0 1 0-2h5V6a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2z" data-name="Path 443" transform="rotate(45 12 12)"/>
      </svg>
    </button>
  </div>

  <!--  <app-applied-filter></app-applied-filter>-->

  <app-search-filter [configurations]="configurations"></app-search-filter>

  <mat-accordion class="filter-options" [multi]="true">

    <app-price-filter ></app-price-filter>

    <app-category-filter    fxHide.xs="true"></app-category-filter>
    @if (isVisible) {
      <app-brand-filter ></app-brand-filter>
    }

  </mat-accordion>

  <div class="show-result-btn" fxHide.gt-md>
    <button type="button" mat-button (click)="closeSideNav()">
      {{ 'globalUi.filter.showResults' | translate: { count: totalElements ? totalElements : '' } }}
    </button>
  </div>
</div>
